import React from 'react';
import { assets } from '../data/landing';
import { AnimatedSection } from './AnimatedSection';
export function TeamSection() {
  return <section className="border-y border-gray-200 bg-gray-50 py-20 sm:py-24" data-id="element-213" data-mp="3pu6dfidfirtd">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-[360px_1fr] lg:gap-20 lg:px-8" data-id="element-214" data-mp="3l1wi1mtjozjp">
        <AnimatedSection data-id="element-215" data-mp="3g3l5h4bv8axs">
          <img src={assets.dan} alt="Dan Knight, founder of Turnout" className="aspect-square w-full rounded-2xl object-cover shadow-lg" data-id="element-216" data-mp="3g20jw47j42c2" />
        </AnimatedSection>
        <AnimatedSection delay={0.06} data-id="element-217" data-mp="36443awvtof6k">
          <h2 className="max-w-3xl text-3xl font-semibold tracking-[-0.02em] text-gray-950 sm:text-4xl" data-id="element-218" data-mp="3242brgjsx250">We&apos;ve been doing B2B business development since 2015.</h2>
          <p className="mt-6 max-w-3xl text-lg leading-8 text-gray-600" data-id="element-219" data-mp="2x6tqv879qk02">
            Turnout was built from years of working with B2B sales teams at
            OpenView Venture Partners and Meritech Capital. We bring that sales
            discipline to the weeks before a conference, when exhibitor pipeline
            is still there to be created.
          </p>
        </AnimatedSection>
      </div>
    </section>;
}